import { render, staticRenderFns } from "./QuotesInMap.vue?vue&type=template&id=9519ddfa&scoped=true&"
import script from "./QuotesInMap.vue?vue&type=script&lang=js&"
export * from "./QuotesInMap.vue?vue&type=script&lang=js&"
import style0 from "./QuotesInMap.vue?vue&type=style&index=0&id=9519ddfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9519ddfa",
  null
  
)

export default component.exports